/* eslint-disable import/order */
/**
 * index.tsx
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import * as serviceWorker from 'serviceWorker';
import { configureAppStore } from 'store/configureStore';

// Initialize languages
import './locales/i18n';

import { theme } from './styles';
// import ErrorBoundary from 'app/containers/ErrorBoundary/ErrorBoundary';
import { Main } from 'app/containers/Main';
import { Auth } from 'app/containers/Auth';

const store = configureAppStore();
const MOUNT_NODE = document.getElementById('root') as HTMLElement;

interface Props {
  Component: typeof Main;
}
const ConnectedApp = ({ Component }: Props) => (
  // <ErrorBoundary>
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <React.StrictMode>
        <Auth>
          <Component />
        </Auth>
      </React.StrictMode>
    </ThemeProvider>
  </Provider>
  // </ErrorBoundary>
);

const render = (Component: typeof Main) => {
  ReactDOM.render(<ConnectedApp Component={Component} />, MOUNT_NODE);
};

render(Main);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
